// extracted by mini-css-extract-plugin
module.exports = {"Container":"ConversationsPopup_Container__3tPzA","Icon":"ConversationsPopup_Icon__3x-hW","Open":"ConversationsPopup_Open__ACGCr","Closed":"ConversationsPopup_Closed__1mQZT"};